var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({staticClass:"mt-0 mb-6",attrs:{"hide-details":"","inset":"","label":_vm.$t(_vm.label),"input-value":_vm.value,"rules":_vm.rules},on:{"change":val => _vm.$emit('input', val)}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }